import { IonText } from '@ionic/react';

import styles from '@components/ChartKey.module.css';

type Props = {
  items: { color: string; count?: number; key: string }[];
  row?: boolean;
};

const ChartKey = ({ items, row = false }: Props) => (
  <div className={`${styles.key} ${row ? styles.row : ''}`}>
    {items.map(item => (
      <div className={`${styles.barKeyItem} ${row ? styles.rowBarKeyItem : ''}`} key={item.key}>
        <div className={`${styles.barKey} ${item.color}`} />
        {item.count && <IonText className={styles.count}>{item.count}</IonText>}
        <div className={`${styles.text} ${row ? styles.rowText : ''}`}>{item.key}</div>
      </div>
    ))}
  </div>
);

export default ChartKey;
